import { useEffect, useState } from "react";
import { ARIA } from "../../scripts/core/constants";
import { useStoreDollHouseMap } from "../../store";
import {
  animationStart,
  animationEnd,
  showPopupWithContent,
  hidePopup,
} from "../../components/customEvents.js";
import { shallow } from "zustand/shallow";

export default function AriaBuildingHotspot({ hoverContent, selectedAria }) {
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      currentAriaMapLevel: state.currentAriaMapLevel,
      sourcePoidSelected: state.sourcePoidSelected,
      destinationPoidSelected: state.destinationPoidSelected,
      AriaL1HighlightPoiStore: state.AriaL1HighlightPoiStore,
      AriaL2HighlightPoiStore: state.AriaL2HighlightPoiStore,
      resetAriaLevel1HighlightPOI: state.resetAriaLevel1HighlightPOI,
      resetAriaLevel2HighlightPOI: state.resetAriaLevel2HighlightPOI,
    }),
    shallow
  );

  const [currentAria, setCurrentAria] = useState(selectedAria);
  const [destinationeastPoiActive, setdestinationeastPoiActive] = useState("");
  const [destinationwestPoiActive, setdestinationwestPoiActive] = useState("");
  const [sourceeastPoiActive, setsourceeastPoiActive] = useState("");
  const [sourcewestPoiActive, setsourcewestPoiActive] = useState("");
  const [highlightarias1, setHighlightArias1] = useState(null);
  const [highlightarias2, setHighlightArias2] = useState(null);

  useEffect(() => {
    //setCurrentAria(selectedAria)
    setCurrentAria(dollhouseStore.currentAriaMapLevel);
  }, [selectedAria]);

  useEffect(() => {
    setCurrentAria(dollhouseStore.currentAriaMapLevel);
  }, [dollhouseStore.currentAriaMapLevel]);

  /*
   * COSMO POLITAN  EXIST Route POI HIGHLIGHTING [start]
   */

  // useEffect(() => {
  //   if (dollhouseStore.sourcePoidSelected === "") {
  //     setsourcewestPoiActive("");
  //   }

  //   if (dollhouseStore.sourcePoidSelected === "aria_west_convention_center") {
  //     setsourcewestPoiActive("active-poi-selection");
  //   }
  // }, [dollhouseStore.sourcePoidSelected]);

  // useEffect(() => {
  //   if (dollhouseStore.destinationPoidSelected === "") {
  //     setdestinationwestPoiActive("");
  //   }

  //   if (
  //     dollhouseStore.destinationPoidSelected === "aria_west_convention_center"
  //   ) {
  //     setdestinationwestPoiActive("active-poi-selection");
  //   }
  // }, [dollhouseStore.destinationPoidSelected]);

  /*
   * COSMO POLITAN  EXIST Route POI HIGHLIGHTING [ends]
   */

  /*
   * COSMO POLITAN NOT  EXIST Route POI HIGHLIGHTING [start]
   */

  useEffect(() => {
    setHighlightArias1(dollhouseStore.AriaL1HighlightPoiStore);
  }, [dollhouseStore.AriaL1HighlightPoiStore]);

  useEffect(() => {
    setHighlightArias2(dollhouseStore.AriaL2HighlightPoiStore);
  }, [dollhouseStore.AriaL2HighlightPoiStore]);

  /*
   * COSMO POLITAN NOT  EXIST Route POI HIGHLIGHTING [ends]
   */

  if (currentAria === ARIA) {
    return (
      <AriaLevel_1_Hotspot
        hoverContent={hoverContent}
        highlightarias={highlightarias1}
        resetAriaLevel1HighlightPOI={dollhouseStore.resetAriaLevel1HighlightPOI}
      />
    );
  } else if (currentAria === "area_level_1") {
    return (
      <AriaLevel_1_Hotspot
        hoverContent={hoverContent}
        highlightarias={highlightarias1}
        resetAriaLevel1HighlightPOI={dollhouseStore.resetAriaLevel1HighlightPOI}
      />
    );
  } else if (currentAria === "area_level_2") {
    return (
      <AriaLevel_2_Hotspot
        hoverContent={hoverContent}
        destinationeastPoiActive={destinationeastPoiActive}
        destinationwestPoiActive={destinationwestPoiActive}
        sourceeastPoiActive={sourceeastPoiActive}
        sourcewestPoiActive={sourcewestPoiActive}
        highlightarias={highlightarias2}
        resetAriaLevel2HighlightPOI={dollhouseStore.resetAriaLevel2HighlightPOI}
      />
    );
  }
}

function AriaLevel_1_Hotspot({
  hoverContent,
  highlightarias,
  resetAriaLevel1HighlightPOI,
}) {
  const [restaurentActive, setrestaurentActive] = useState("");

  useEffect(() => {
    document.querySelectorAll(".poi-hover").forEach((val) => {
      val.classList.remove("active-poi");
    });
    setrestaurentActive("");
    if (highlightarias !== "") {
      if (highlightarias === "aria_level_restaurent") {
        setrestaurentActive("active-poi");
      } else {
        if (document.getElementById(highlightarias)) {
          document.getElementById(highlightarias).classList.add("active-poi");
        }
      }
    }
  }, [highlightarias]);

  return (
    <>
      <g transform="translate(1924.587 1442.952)">
        <g
          id="aria_guest_elevators"
          className="poi-hover"
          onTouchStart={(e) => {
            showPopupWithContent(e, "aria_guest_elevators");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("aria_guest_elevators");
            showPopupWithContent(e, "aria_guest_elevators");
          }}
          onMouseLeave={(e) => {
            animationEnd("aria_guest_elevators");
            hidePopup("aria_guest_elevators");
            resetAriaLevel1HighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("aria_guest_elevators");
            resetAriaLevel1HighlightPOI();
          }}
          fill="rgba(24,92,210,0)"
        >
          <path
            id="skysuite-elev"
            d="M331.087,184.258l3.862,42.254,57.409-7.136,31.552-2.061-1.768-47.622-41.665,6.546-27.1,4.746Z"
          />
          <path
            id="Path_2154"
            data-name="Path 2154"
            d="M686.037,270.355l29.457,12.8,29.751,13.713,33.024,16.659,38.1,23.8,35.12,25.889,29.457,24.973,26.478,25.3,8.936,10.408,18.427,17.87-14.859,46.117-54.463-27.984v-7.431l-66.049-45.822-40.781-26.184L719.356,352.18l-53.841-55.313Z"
          />
        </g>

        <g
          className="poi-hover"
          id="lobby"
          onTouchStart={(e) => {
            showPopupWithContent(e, "lobby");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("lobby");
            showPopupWithContent(e, "lobby");
          }}
          onMouseLeave={(e) => {
            animationEnd("lobby");
            hidePopup("lobby");
            resetAriaLevel1HighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("lobby");
            resetAriaLevel1HighlightPOI();
          }}
          fill="rgba(24,92,210,0)"
        >
          <path
            id="aria-lobby"
            d="M-4672.63-10784.672l-16.881-28.64-11.619,5.148-9.229-13.892,80.646-71.123,22.617,1.473,46.523,98.7,1.168,3.017,19.506-5.85,1.461,6.566,43.446-9.824-1.222-9.066,15.5-5.148,13.059,48.366,79.782-23.633,35.75,57.243-14.9,17.622,8.15,129.611-55.1-4.554,9.642-38.651h-17.406l-224.207,1.026v-3.618h-2.437l-1.486-45.94-1.146-27.533-11.813-56.121Z"
            transform="translate(5380.5 11517.853)"
          />
          <path
            id="Path_2151"
            data-name="Path 2151"
            d="M408.428,123.282h83.919v34.5l-83.919,10.408Z"
          />
        </g>

        <path
          className="poi-hover"
          id="aria_connection_from_aria_vidara"
          d="M-4261.233-11427.641l15.656-16.378,27.635,21.563,31.315,16.959,37.667,12.859,35.27,6.146,40.542,1.785,16.493-1.073-8.924,25.479-180.556-21.187,8.513-35.246Z"
          transform="translate(5214.601 11772.189)"
          fill="rgba(255,255,255,0.03)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "aria_connection_from_aria_vidara");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("aria_connection_from_aria_vidara");
            showPopupWithContent(e, "aria_connection_from_aria_vidara");
          }}
          onMouseLeave={(e) => {
            animationEnd("aria_connection_from_aria_vidara");
            hidePopup("aria_connection_from_aria_vidara");
            resetAriaLevel1HighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("aria_connection_from_aria_vidara");
            resetAriaLevel1HighlightPOI();
          }}
        />

        <g
          id="aria_restaurent_1"
          fill="rgba(255,255,255,0)"
          className={`poi-hover ${restaurentActive}`}
          onTouchStart={(e) => {
            showPopupWithContent(e, "aria_restaurent_1");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("aria_restaurent_1");
            showPopupWithContent(e, "aria_restaurent_1");
            setrestaurentActive("active-poi");
          }}
          onMouseLeave={(e) => {
            animationEnd("aria_restaurent_1");
            hidePopup("aria_restaurent_1");
            setrestaurentActive("");
            resetAriaLevel1HighlightPOI();
          }}
          onTouchEnd={(e) => {
            hidePopup("aria_restaurent_1");
            setrestaurentActive("");
            resetAriaLevel1HighlightPOI();
          }}
          transform="translate(2.962 3.632)"
        >
          <path
            id="Path_2059"
            data-name="Path 2059"
            d="M-5382.27-11987.772l86.558-.1v54.71l-59.812,95.59h-24.195l-35.219-56.263Z"
            transform="translate(5676.878 11987.869)"
          />
          <path
            id="Path_2060"
            data-name="Path 2060"
            d="M-5664.391-11803.084h50.471l-.032,48.676H-5597l6.187,16.074,16.521,22.607,9.139,7.566-65.257,34.553-33.977-62.68Z"
            transform="translate(5777.472 11913.353)"
          />
          <path
            id="Path_2061"
            data-name="Path 2061"
            d="M-5853.887-11465.244h98.3v61.921l-9.474,2.367-8.921,3.678-6.532,5.044-5.243,5.62-3.23,4.945-2.437,6.938-.9,6.8v8.827l1.405,7.064,2.681,6.654,3.025,4.086,3.124,3.245,4.029,4.41v1.67h-32.271v-103.841h-43.554Z"
            transform="translate(5853.887 11777.117)"
          />
          <path
            id="Path_2063"
            data-name="Path 2063"
            d="M-4555.738-11571.317l40.572-31.537,17.757,24.1,15.04,18.569,18.875,18.866,20.571,18.438,22.49,16.277,27.279,15.344,29.829,13.788-8.814,36.858,184.781,21.977,14.569,108.029,76.592,63.721-87.321,19.243-15.835-28.374-13.279-20.965-12.25-15.418-13.9-15.04-17.438-15.31-12.748-9.437-10.539-7.44-6.227-4.731-113.948,45.807-24.684-9.439,29.376-85.811-27.606-27.021,4.4-6.785,6.012,6.785,5.3.671-1.363-3.808-25.916-33.354-25.21-30.265-17.315-18.208-10.989-10.91-11.852-11.171-17.952-14.958-16.853-13.166Z"
            transform="translate(5330.4 11832.609)"
          />
          <path
            id="Path_2064"
            data-name="Path 2064"
            d="M-4167.778-10931.5l57.932-24.078v-3.4l174.082-38.083,14.2,61.574-135.02,30.07,4.868,23.807-98.084,21.592-6.893-22.063Z"
            transform="translate(5173.953 11588.316)"
          />
          <path
            id="Path_2065"
            data-name="Path 2065"
            d="M-3981.3-10857.728l141.917-30.572,22.64,104.138-42.76,4.469-1.57,43.485-94.723,17.421-12.188-63.821-17.232,3.115-5.043-14.169-4.6-20-.847-16.424,19.443-4.4Z"
            transform="translate(5104.563 11544.461)"
          />
          <path
            id="Path_2066"
            data-name="Path 2066"
            d="M-4145.475-10685.818l20.632-3.48v4.409l86.595-15.2,12.88,68.92v92.746l-124.095.506-3.262-5.317-7.752-124.869Z"
            transform="translate(5171.009 11468.564)"
          />
          <path
            id="Path_2067"
            data-name="Path 2067"
            d="M-5703.827-10886.023h42.791l16.135,9.2,4.14-4.307,24.98,11.761-4.96,13.562-33.957-9.857-49.129,13.76Z"
            transform="translate(5793.375 11543.543)"
          />
          <path
            id="Path_2068"
            data-name="Path 2068"
            d="M-5123.323-11070.348l22.072-1.457h15.763l20.167,1.457,15.591,2.021,16.275,2.9,13.145,2.7,13.875,3.936,17.3,5.648,18.271,6.588,21.557,10.111,13.7,7.257,10.68,6.556-30.821,40.345-18.343-9.426-12.3-5.009-17.031-5.49-13.269-3.592-15.367-3.393-17.322-2.247-17.394-1.018-25.312,1-13.583,1.88-9.407,1.284Z"
            transform="translate(5559.282 11618.46)"
          />
          <path
            id="Path_2062"
            data-name="Path 2062"
            d="M-4767.463-11473.065l13.112-17,10.98,11.854,13.421,14.209,13.693,13.077,13.575,12.39,18.37,15.747,19.048,15.108,16.95,13.11-22.3,33.8-3.232,3.434-3.214,1.23-3.762.357-2.568-.357-2.816-1.23-2.163-1.9-1.279-2.208-.632-1.729-.781-3.182-.3-1.831-.375-1.972-.611-1.954-1.687-1.824-2.011-1.093-2.151-.2-1.895.2-2.078.754-1.5.937-1.927.627h-2.217l-2.5-.448-1.812-.913-1.952-1.159-1.575-1.373-1.55-2.219-.821-2.847-.2-3.042v-6.1l-.446-1.693-1.708-2.177-1.876-1.127-2.556-.522-2.208.315-2.46.845-1.371.679-1.822.459-1.854.208-2.721-.208-1.813-.648-1.622-.766-2.093-1.641-1.481-2.062-1.043-1.877-.422-2.458v-2.427l.217-2.618.205-3.073-.205-2.76-.979-2.385-1.878-1.525-1.774-.661h-2.4l-1.934.661-1.54.794-2.065.731-2.886.286-2.854-.286-2.393-1-2.78-1.925-1.9-2.727-.935-2.229-.454-1.908v-2.923l1.034-2.676,1.178-2.121,1.077-2.01.437-3.111-.437-2.5-1.9-2.039-1.877-1.532,1.29-1.421-6.214-7.917,11.482-15.833Z"
            transform="translate(5419.905 11787.127)"
          />
        </g>
      </g>
    </>
  );
}

function AriaLevel_2_Hotspot({
  hoverContent,
  destinationeastPoiActive,
  destinationwestPoiActive,
  sourceeastPoiActive,
  sourcewestPoiActive,
  highlightarias,
  resetAriaLevel2HighlightPOI,
}) {
  const [restaurentActive, setrestaurentActive] = useState("");
  const [conventionActive, setconventionActive] = useState("");

  useEffect(() => {
    document.querySelectorAll(".poi-hover").forEach((val) => {
      val.classList.remove("active-poi");
    });
    setrestaurentActive("");
    setconventionActive("");

    if (highlightarias !== "") {
      if (highlightarias === "aria_level_restaurent") {
        setrestaurentActive("active-poi");
      }
      if (highlightarias === "aria_west_convention_center") {
        setconventionActive("active-poi");
      } else {
        if (document.getElementById(highlightarias)) {
          document.getElementById(highlightarias).classList.add("active-poi");
        }
      }
    }
  }, [highlightarias]);

  return (
    <>
      {/* <path
        fill="rgba(255,255,255,0)"
        className="poi-hover"
        onTouchStart={(e) => {
          showPopupWithContent(e, "aria_guest_elevators");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("aria_guest_elevators");
          showPopupWithContent(e, "aria_guest_elevators");
        }}
        onMouseLeave={(e) => {
          animationEnd("aria_guest_elevators");
          hidePopup("aria_guest_elevators");
          resetAriaLevel2HighlightPOI();
        }}
        onTouchEnd={(e) => {
          hidePopup("aria_guest_elevators");
          resetAriaLevel2HighlightPOI();
        }}
        id="aria_guest_elevators"
        d="M-4832.116-11752.06l19.364-1.478,15.989,31.059,2.4-1.057,16.487,25.976,42.93-24.11-1.028-10.338,30.121-1.425,4.869,29.691,17.674,44.062,18.825,26.307,20.443,20.079,23.076,16.7,49.057,22.521-28.666,59.843-9.723-12.777-16.139,21.021-8.688-7.015,16.9-20.589-23.47-25.34-22.788,29.471-9.388-6.434,23.327-28.807-24.911-20.679-25.474,31.854-9.316-5.406,24.972-32-24.972-19.034-23.106,26.688-9.387-4.944,20.055-26.638-25.967-17.1-18.484,21.99-8.468-4.895,14.215-20.377-18.555-12.27-31.311,37.541-12.807-25.271,41.7-27.606-6.752-12.467-5.251,1.968,5.251,7.945-37.684,25.165-9.835-20.526,1.947-10.736,31.191-17.755,5.869,10.008,4.261-2.215-12.222-21.623-4.17,2.462,3.2,5.867-30.074,17.927-10.134-18.639,29.82-16.853,3.771,6.329,4.63-2.571-7.375-13.914-2.741,1.515-10.676-18.926,3.577-1.433Z"
        transform="translate(7371.131 13339.957)"
      /> */}

      <g
        fill="rgba(255,255,255,0)"
        className="poi-hover"
        id="aria_guest_elevators"
        onTouchStart={(e) => {
          showPopupWithContent(e, "aria_guest_elevators");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("aria_guest_elevators");
          showPopupWithContent(e, "aria_guest_elevators");
        }}
        onMouseLeave={(e) => {
          animationEnd("aria_guest_elevators");
          hidePopup("aria_guest_elevators");
          resetAriaLevel2HighlightPOI();
        }}
        onTouchEnd={(e) => {
          hidePopup("aria_guest_elevators");
          resetAriaLevel2HighlightPOI();
        }}
      >
        <path
          id="aria-l2-guest-elevators"
          d="M-4832.116-11752.06l19.364-1.478,15.989,31.059,2.4-1.057,16.487,25.976,42.93-24.11-1.028-10.338,30.121-1.425,4.869,29.691,17.674,44.062,18.825,26.307,20.443,20.079,23.076,16.7,49.057,22.521-28.666,59.843-9.723-12.777-16.139,21.021-8.688-7.015-24.531-17.168-6.234,3.162-13.092-5.714,5.17-7.354-21.348-14.94-5.826,7.437-17.568-9.525,5.957-10.113-80.768-58.914-17.893,16.164-12.807-25.271,41.7-27.606-6.752-12.467-5.251,1.968,5.251,7.945-37.684,25.165-9.835-20.526,1.947-10.736,31.191-17.755,5.869,10.008,4.261-2.215-12.222-21.623-4.17,2.462,3.2,5.867-30.074,17.927-10.134-18.639,29.82-16.853,3.771,6.329,4.63-2.571-7.375-13.914-2.741,1.515-10.676-18.926,3.577-1.433Z"
          transform="translate(7371.131 13339.957)"
        />
        <path
          id="Path_2153"
          data-name="Path 2153"
          d="M2349.086,1707.8l60.651-7.3v-34.794l-69.563,8.006,2.744,35.248Z"
        />
      </g>

      <path
        className="poi-hover"
        id="aria_connection_from_aria_vidara"
        d="M-4261.233-11427.641l15.656-16.378,27.635,21.563,31.315,16.959,37.667,12.859,35.27,6.146,40.542,1.785,16.493-1.073-8.924,25.479-180.556-21.187,8.513-35.246Z"
        transform="translate(7138 13215)"
        fill="rgba(255,255,255,0.03)"
        onTouchStart={(e) => {
          showPopupWithContent(e, "aria_connection_from_aria_vidara");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("aria_connection_from_aria_vidara");
          showPopupWithContent(e, "aria_connection_from_aria_vidara");
        }}
        onMouseLeave={(e) => {
          animationEnd("aria_connection_from_aria_vidara");
          hidePopup("aria_connection_from_aria_vidara");
          resetAriaLevel2HighlightPOI();
        }}
        onTouchEnd={(e) => {
          hidePopup("aria_connection_from_aria_vidara");
          resetAriaLevel2HighlightPOI();
        }}
      />
      <path
        fill="rgba(255,255,255,0)"
        className="poi-hover"
        onTouchStart={(e) => {
          showPopupWithContent(e, "aria_spa_area");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("aria_spa_area");
          showPopupWithContent(e, "aria_spa_area");
        }}
        onMouseLeave={(e) => {
          animationEnd("aria_spa_area");
          hidePopup("aria_spa_area");
          resetAriaLevel2HighlightPOI();
        }}
        onTouchEnd={(e) => {
          hidePopup("aria_spa_area");
          resetAriaLevel2HighlightPOI();
        }}
        id="aria_spa_area"
        d="M-4934.574-12861.242l22.2,20.006.523,393.53-50.036-12.477-3.644,14.075-3.679,26.724.7,33.709-79.471-5.714v-3.439l-25.3-2.842v2.842l-20.8-.959.734-32.5,1.5-17.465,4.218-30.971,5.479-25.691,5-15.006,21.732,9.951,1.587-56.769,3.559-38.823,4.607-28.271,2.637-14.812,3.893-15.415,3.961-15.259,6.055-18.8h20.148v12.467h26.985v-35.382h-26.985v10.6h-15.016l13.011-33.632,21.788-43.583,14.247-24.868,1.781-3.077,13.977-20.13,6.547-8.532,8.046-9.4Z"
        transform="translate(7470.86 13786.646)"
      />

      <path
        fill="rgba(255,255,255,0)"
        className="poi-hover"
        onTouchStart={(e) => {
          showPopupWithContent(e, "aria_pool_area");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("aria_pool_area");
          showPopupWithContent(e, "aria_pool_area");
        }}
        onMouseLeave={(e) => {
          animationEnd("aria_pool_area");
          hidePopup("aria_pool_area");
          resetAriaLevel2HighlightPOI();
        }}
        onTouchEnd={(e) => {
          hidePopup("aria_pool_area");
          resetAriaLevel2HighlightPOI();
        }}
        id="aria_pool_area"
        d="M-5728.569-12809.348h193.724v10.048h36.007v-12.874h276.563l-13.478,19.554-13.959,24.558-12.333,24.45-9.512,19.665-15.285,38.665h8.219l-1.781,6.691h-9.443l-5.762,17.8-6.908,25.6-4.86,23.595-4.2,28.488-2.534,28.455-.983,16.191-.866,23.3-.9,23.011-20.775-9.524-6.071,18.411-5.164,24.832-4.412,31.682-1.609,17.63-.771,21.412v12.11l-2.974.733-9.793-14.237-11.361,5.74,8.738,16.309-2.409,9.7-12.417,7.092,5.79,16.046h25.461l3.519,47.777-23.223.728-23.119,1.729-16.082,2.894-17.7,4.107-4.734,1.007-2.172-11.088-12.494,11.751,4.721,5.4-3.89,4.662-6.327,5.846-6.007,4.646-8.69,5.341-8.576,4.419-7.879,3.089-7.9,1.149h-7.483v-5.668H-5519.4l11.22,30.88h-79.15l-18.694-22.65,33.528-59.917-6.926-15.665-12.185-16.736-14.058-16.185-14.249-13.519-19.327-15.276-16.149-9.006-10.374,91.332-14.936-1.483v31.326h-19.128v-4.577h-29.634v-20.038h-6.118l10.288-46.27,4.838-41.386,3.306-57.368,3.146-93.062-1.19-70.8-4.416-88.391Z"
        transform="translate(7729.55 13766.859)"
      />

      {/* <g
        fill="rgba(255,255,255,0)"
        className={`poi-hover  ${conventionActive}  `}
        onTouchStart={(e) => {
          showPopupWithContent(e, "aria_west_convention_center");
          setconventionActive("active-poi");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("aria_west_convention_center");
          showPopupWithContent(e, "aria_west_convention_center");
          setconventionActive("active-poi");
        }}
        onMouseLeave={(e) => {
          animationEnd("aria_west_convention_center");
          hidePopup("aria_west_convention_center");
          setconventionActive("");
          resetAriaLevel2HighlightPOI();
        }}
        id="aria_west_convention_center"
        transform="translate(1675.928 949.163)"
      >
        <path
          id="Path_2049"
          data-name="Path 2049"
          d="M-6268.544-12821.353l270.6-.077v19.817h6.649v48.822h-6.649v34.857h47.966l7.4,130.122v83.384l-3.235,74.6-2.426,48.89-2.526,13.2h-44.481v43.813h4.6v14.012h-25.807v13.694l-251.982.15Z"
          transform="translate(6268.544 12821.43)"
        />
      </g> */}
      <g
        fill="rgba(255,255,255,0)"
        className={`poi-hover  ${conventionActive}`}
        onTouchStart={(e) => {
          showPopupWithContent(e, "aria_west_convention_center");
          setconventionActive("active-poi");
        }}
        onTouchEnd={(e) => {
          hidePopup("aria_west_convention_center");
          setconventionActive("");
          resetAriaLevel2HighlightPOI();
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("aria_west_convention_center");
          showPopupWithContent(e, "aria_west_convention_center");
          setconventionActive("active-poi");
        }}
        onMouseLeave={(e) => {
          animationEnd("aria_west_convention_center");
          hidePopup("aria_west_convention_center");
          setconventionActive("");
          resetAriaLevel2HighlightPOI();
        }}
        id="aria_west_convention_center"
        transform="translate(1675.928 949.163)"
      >
        <path
          id="Path_2049"
          data-name="Path 2049"
          d="M-6268.544-12821.353l270.6-.077v19.817h6.649v48.822h-6.649v34.857h47.966l7.4,130.122v83.384l-3.235,74.6-2.426,48.89-2.526,13.2h-44.481v43.813h4.6v14.012h-25.807v13.694l-251.982.15Z"
          transform="translate(6268.544 12821.43)"
        />
        <path
          id="Path_2050"
          data-name="Path 2050"
          d="M-6022.818-11837.76l172.2-.054v35.157h32.328v-35.157h29.906v-39.582h33.471v15.735l1.459,12.768,2.166,13.959,6.067,26.174,11.47,30.578,24.319,40.186,24.673,26.045,27.38,20.783,20.259,57.09-47.639,33.885.052-34.576H-5698v9.636l-228.894.211-13.581-7.895-23.43-.813-13.945-1.583-14.618-5.15-13.765-10.16-10.188-12.763-5.316-13.361-1.286-10.927v-40.231Z"
          transform="translate(6169.536 12440.742)"
        />
        <path
          id="Path_2089"
          data-name="Path 2089"
          d="M3465.539,2407.333l10.156-91.215,16.573,9.313,18.9,15.336,14.3,13.435,14.249,16.236,12.294,16.768,6.441,15.4-33.257,55.718-1.677-33.106-6.169-2.594-6.409-2.2-9.376-2.927-9.068-2.484-7.8-2.052-9.15-1.759-10.013-1.349Z"
          transform="translate(-3077.606 -1883.152)"
        />
        <path
          id="Path_2090"
          data-name="Path 2090"
          d="M3385.047,2515.162v6.4h25.732v43.474H3354.11l-.047-49.877Z"
          transform="translate(-3032.653 -1963.418)"
        />
      </g>

      <g
        className={`poi-hover ${restaurentActive}`}
        id="aria_level_2_restaurent_5"
        onTouchStart={(e) => {
          showPopupWithContent(e, "aria_level_2_restaurent_5");
          setrestaurentActive("active-poi");
        }}
        onTouchEnd={(e) => {
          hidePopup("aria_level_2_restaurent_5");
          setrestaurentActive("");
          resetAriaLevel2HighlightPOI();
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("aria_level_2_restaurent_5");
          showPopupWithContent(e, "aria_level_2_restaurent_5");
          setrestaurentActive("active-poi");
        }}
        onMouseLeave={(e) => {
          animationEnd("aria_level_2_restaurent_5");
          hidePopup("aria_level_2_restaurent_5");
          setrestaurentActive("");
          resetAriaLevel2HighlightPOI();
        }}
        fill="rgba(255,255,255,0)"
        transform="translate(2143.896 1483.941)"
      >
        <path
          id="Path_2051"
          data-name="Path 2051"
          d="M-5484.342-11854.289l79.108-.194-9.578-30.706h13.259v3.006h7.218l8.444-1.425,8.521-3.261,9.26-5.181,7.958-4.791,10.41-8.887,5.1-5.311-2.921-3.754,9.349-8.78,12.429,87.16-64.6,23.105,10.971,34.622-37.841,17.259-8.608,3.141-8.067.314-5.395-.851-6.765-4.617-4.771-7.206-3.915-13.408-2.621-13.738-4.989-17.194-10.23-21.427Z"
          transform="translate(5484.342 11924.584)"
        />

        <path
          id="Path_2052"
          data-name="Path 2052"
          d="M-5231.083-11914.83l21.647-5.048,15.616-2.771,22.688-1.9,24.011-.722,2.4,21.848,77.963-6.295,2.428,14.551,2.776,10.837,4.841,14.263,21.113,50.222-62.073,12.027-2.777-7.7-86.372,1.678,1.156,13.2-31.985,6.01-8.817-37.5,6.7-2.78Z"
          transform="translate(5382.213 11925.269)"
        />

        <path
          id="Path_2053"
          data-name="Path 2053"
          d="M-4878.973-11729.374l31.815-15.6,17.277,31.489-33.795,18.014Z"
          transform="translate(5240.223 11852.563)"
        />

        <path
          id="Path_2054"
          data-name="Path 2054"
          d="M-4754.316-11724.489l52.729-28.022.791,29.658-38.891,21.66Z"
          transform="translate(5189.955 11855.604)"
        />

        <path
          id="Path_2055"
          data-name="Path 2055"
          d="M-5305.8-11483.584l3.6,4.949,3.364-.846,7.979,17.531-4.023,1.232,14.3,34.309-10.281,5.574-7.979,3.279-9.317,3.857-8.141,4.053-14.832,7.752-7.1,5.063-16.928-34.516-12.828-20.367Z"
          transform="translate(5437.418 11747.156)"
        />

        <path
          id="Path_2056"
          data-name="Path 2056"
          d="M-5137.943-11531.68l23.336-4.614,17.375-2.468,47.229-1.5h22.508l-1.045,66.488-33.572-.6h-19.208l-15.912,1.763-20.646,2.909-10.661,2.246Z"
          transform="translate(5344.654 11770.012)"
        />

        <path
          id="Path_2057"
          data-name="Path 2057"
          d="M-5229.15-11391.455l22.29-9.68v-2.835l13.373-4.687v1.914l19.941-5.2,19.875-4.519,19.558-2.84,16.292-1.261,2.106,59.115-22.586,3.945-24.252,6.662-18.22,6.6-18.29,8Z"
          transform="translate(5381.435 11721.741)"
        />
      </g>
    </>
  );
}
